import type { AnchorHTMLAttributes, ReactNode } from 'react'

interface ButtonLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  children: ReactNode
  variant?: 'primary' | 'outline'
  green?: boolean
}

export function ButtonLink({ children, variant = 'primary', green = false, className = '', ...props }: ButtonLinkProps) {
  const classes = [variant === 'primary' ? 'primary-button' : 'outline-button', green ? 'green' : '', 'magnetic', className]
    .filter(Boolean)
    .join(' ')
  return <a className={classes} {...props}>{children}</a>
}
